export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl border border-background-200/80 bg-background-50 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-shrink-0">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-3xl bg-gradient-to-br from-primary-400 to-accent-500 flex items-center justify-center">
                <i className="ri-smartphone-line text-5xl text-white"></i>
              </div>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
                随时随地访问每日大赛入口
              </h2>
              <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-lg">
                每日大赛入口已全面适配移动端，无论你使用手机还是平板，都能流畅浏览每日大赛作品介绍、
                每日大赛类型列表和每日大全。收藏每日大赛入口官网，大赛内容随时掌握。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-foreground-900 text-background-50 cursor-pointer transition-opacity hover:opacity-90 whitespace-nowrap">
                  <i className="ri-apple-fill"></i>
                  <span className="text-xs font-medium">iOS 版</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-foreground-900 text-background-50 cursor-pointer transition-opacity hover:opacity-90 whitespace-nowrap">
                  <i className="ri-android-fill"></i>
                  <span className="text-xs font-medium">Android 版</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-foreground-300 text-foreground-700 cursor-pointer transition-colors hover:bg-background-100 whitespace-nowrap">
                  <i className="ri-computer-line"></i>
                  <span className="text-xs font-medium">网页版</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}